module.exports = __webpack_public_path__ + "img/list6.87d22027.png";